import { render, staticRenderFns } from "./TextInputCard.vue?vue&type=template&id=2a37c930&scoped=true&"
import script from "./TextInputCard.vue?vue&type=script&lang=js&"
export * from "./TextInputCard.vue?vue&type=script&lang=js&"
import style0 from "./TextInputCard.vue?vue&type=style&index=0&id=2a37c930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a37c930",
  null
  
)

export default component.exports